<template>
    <div class="container">
       <img :src="itemData.url" alt="" @click="goToNotifications">
    </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
const router = useRouter()
const props = defineProps<{
    itemData: {
        url: string,
        redirect_url: string,
        display: boolean,
    }
}>()
const goToNotifications = () => {
    router.push('/sd-message')
}

</script>
<style scoped>
.container {
    position: fixed;
    bottom: 65px;
    left: 15px;
}

.container img {
    border-radius: 10px;
    width: 50px;
}
</style>